{
  "version": 1,
  "asset_id": "bd07011b-4692-480a-9963-512588c22a56",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/bd07011b-4692-480a-9963-512588c22a56/svc-analytics-reporting-1200.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/bd07011b-4692-480a-9963-512588c22a56/svc-analytics-reporting-1200.avif",
  "original_filename": "svc-analytics-reporting-1200.avif",
  "size": 21418,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:42Z"
}
